import { getTables, getTableColumnsData, getTableFullColumnsData, setTableColumnsData, removeTableColumnsData, getKeysFromDefaultColumns } from '@/utils/columns'

const state = {
  // current user info

  tables: getTables(),
  columns: {
    getOrDefault (tableKey, defaultValue = null) {
      return this.get(tableKey) || defaultValue
    },
    get (tableKey) {
      return state.columnsHolder[tableKey]
    },
    getFull () {
      return getTableFullColumnsData()
    },
    has (tableKey) {
      return this.get(tableKey) != null
    }
  },
  columnsHolder: {}
}

const mutations = {
  SET_COLUMNS_DATA (state, { tableKey, columnsData }) {
    setTableColumnsData(tableKey, columnsData)
    state.columnsHolder[tableKey] = columnsData
  },
  REMOVE_COLUMNS_DATA (state, tableKey) {
    removeTableColumnsData(tableKey)
    delete state.columnsHolder[tableKey]
  }
}

const actions = {
  setTableColumns ({ commit }, { tableKey, columnsData }) {
    commit('SET_COLUMNS_DATA', { tableKey, columnsData })
  },
  autoinit ({ commit, state }) {
    getKeysFromDefaultColumns().forEach(tableKey => {
      state.columnsHolder[tableKey] = getTableColumnsData(tableKey)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/columns.js